export class Populations {
  public static Default = 'Default';
}
